import React from 'react';
import { Link } from 'react-router-dom';
import LayoutWrapper from '../layout/LayoutWrapper'
import TermsAndConditionsView from './TermsAndConditionsView';


export default LayoutWrapper(TermsAndConditionsView, {showNavigationBar:true, showSideMenu:true});